import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=60c905f2&scoped=true"
import script from "./trend.vue?vue&type=script&lang=js"
export * from "./trend.vue?vue&type=script&lang=js"
import style0 from "../../../style/common-pc.scss?vue&type=style&index=0&id=60c905f2&prod&lang=scss&scoped=true&external"
import style1 from "../../../style/exchange-shop/pc/common.scss?vue&type=style&index=1&id=60c905f2&prod&lang=scss&scoped=true&external"
import style2 from "./trend.vue?vue&type=style&index=2&id=60c905f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c905f2",
  null
  
)

export default component.exports